import { all, takeLatest, call, put, delay } from 'redux-saga/effects';
import LoginActionTypes from './types';
import { fetchUserStart } from 'redux/user/actions';
import {
  endSession,
  startSession,
  setBasemapSession
} from 'redux/session/actions';
import {
  initAppFailure,
  initAppSuccess,
  resetAppAuthStateFinish
} from 'redux/app/actions';
import {
  createBasemapSession,
  getStoredSession,
  isSessionValid,
  clearSession
} from 'utilities/basemap-session.util';
import {
  initializeBasemapTokenInterceptors,
  setBasemapSessionToken
} from 'utilities/basemap-token-interceptor.util';
import { debugLog, debugError } from 'utilities/basemap-debug.util';

function* handleFetch(): any {
  try {
    yield put(fetchUserStart());
    yield put(startSession());

    // Initialize basemap session
    try {
      // Initialize token interceptors once
      initializeBasemapTokenInterceptors();

      // Check for existing valid session in localStorage
      const existingSession = getStoredSession();

      if (existingSession && isSessionValid(existingSession)) {
        debugLog('Restoring existing basemap session from storage');
        yield put(setBasemapSession(existingSession));
        setBasemapSessionToken(existingSession.sessionToken);
      } else {
        // Create new session if not found or expired
        if (existingSession && !isSessionValid(existingSession)) {
          debugLog('Existing session expired, creating new one');
          clearSession();
        }

        // Hardcoded API key as requested for testing
        const apiKey = process.env.REACT_APP_ESRI_API_KEY;
        if (!apiKey) {
          throw new Error('ArcGIS API key is not set');
        }
        debugLog('Creating new basemap session with API key');
        const newSession: any = yield call(createBasemapSession, apiKey);
        yield put(setBasemapSession(newSession));
        setBasemapSessionToken(newSession.sessionToken);
      }
    } catch (sessionError) {
      debugError('Failed to initialize basemap session:', sessionError);
      // Don't block app initialization if basemap session fails
    }

    yield put(initAppSuccess());
  } catch {
    yield put(initAppFailure());
  }
}
function* watchFetchRequest() {
  yield takeLatest(LoginActionTypes.INIT_APP_LOADING, handleFetch);
}
function* handleCleanAppState() {
  yield delay(1200);
  yield put(resetAppAuthStateFinish());
  yield put(endSession());
}
function* watchCleanAppState() {
  yield takeLatest(
    LoginActionTypes.RESET_APP_AUTH_STATE_START,
    handleCleanAppState
  );
}
function* appSagas() {
  yield all([call(watchFetchRequest), call(watchCleanAppState)]);
}
export default appSagas;
